import { fonts, flex, absoluteBottomRight } from '../../OpportunityWorkspace.style';
import { CARD, ellipsisOneLine, lineClamp } from '../../utils';

export const root = {
    position: 'relative',
    width: '100%',
    height: CARD.fixedHeight,
    minHeight: CARD.fixedHeight,
    maxHeight: CARD.fixedHeight,
    borderRadius: CARD.radius,
    border: CARD.border,
    backgroundColor: CARD.bg,
    overflow: 'hidden',
    boxSizing: 'border-box',
    ...flex.col,
};

export const inner = {
    position: 'relative',
    zIndex: 1,
    flex: 1,
    ...flex.stretchCol,
    gap: CARD.gap,
    padding: `${CARD.pad}px`,
    paddingBottom: CARD.pad,
    maxWidth: '100%',
    minHeight: 0,
    minWidth: 0,
    height: '100%',
    boxSizing: 'border-box',
};

export const headerBlock = {
    ...flex.col,
    gap: 4,
    width: '100%',
    minWidth: 0,
    flexShrink: 0,
};

export const eyebrowTypography = {
    fontSize: 11,
    fontWeight: 500,
    lineHeight: 1.2,
    color: CARD.eyebrow,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    fontFamily: fonts.sans,
    ...ellipsisOneLine,
};

export const titleTypography = {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: 1.25,
    color: CARD.title,
    fontFamily: fonts.sans,
    ...lineClamp(2),
};

/** Wrapper so Tooltip’s trigger is a normal block flex item (not an inline span that breaks flex-grow). */
export const descriptionWrap = {
    flexShrink: 0,
    minWidth: 0,
    width: '100%',
};

export const descriptionTypography = {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    color: CARD.body,
    width: '100%',
    minWidth: 0,
    maxHeight: 32,
    fontFamily: fonts.sans,
    cursor: 'default',
    ...lineClamp(2),
};

export const actionButton = {
    marginTop: 'auto',
    height: 32,
    minHeight: 32,
    minWidth: 'unset',
    alignSelf: 'flex-start',
    width: 'auto',
    maxWidth: '100%',
    justifyContent: 'center',
    overflow: 'hidden',
    padding: '0 8px',
    borderRadius: 4,
    textTransform: 'none',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1,
    color: CARD.green,
    border: '1px solid rgba(59, 167, 104, 0.5)',
    fontFamily: fonts.sans,
    flexShrink: 0,
    boxSizing: 'border-box',
};

export const buttonLabel = {
    ...ellipsisOneLine,
    display: 'block',
    maxWidth: '100%',
};

export const cornerIcon = {
    width: 51,
    height: 65,
    ...absoluteBottomRight,
};
